import React, { FC, useEffect } from 'react';
import { Wrapper, AddNewType } from './styles';
import { Header, LayoutComponent } from './components';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from 'common/hooks/redux';
import { resetAppointmentTypeChanges } from 'applicaiton/store/reducers/AppointmentTypes/AppointmentTypesSlice';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const AppointmentTypeAdd: FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    return () => {
      dispatch(resetAppointmentTypeChanges());
    };
  }, []);

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />
      <AddNewType>{t('appointment_types.add_appointment_types')}</AddNewType>
      <LayoutComponent />
    </Wrapper>
  );
};

export default AppointmentTypeAdd;
